import { IDealerCenterContact } from '@/interfaces/dealers.interfaces';

const getDealerPhones = (contacts: Array<IDealerCenterContact>) => {
  if (!contacts) {
    return [];
  }
  return contacts.map(({ phone }) => phone);
};

export default getDealerPhones;
